import { fetchBaseQuery } from '@reduxjs/toolkit/query'
import type { BaseQueryFn, FetchArgs, FetchError } from '@reduxjs/toolkit/query'

import type { RootState } from '../index'
import { slice as authSlice } from '../auth'

const BASE_URL = import.meta.env.VITE_BASE_URL

export const baseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as RootState).auth.accessToken
      ?? localStorage.getItem('accessToken')
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    return headers
  },
})

export const baseQueryWithAuth: BaseQueryFn<string | FetchArgs, unknown, FetchError> = async (
  args,
  api,
  extraOptions,
) => {
  const result = await baseQuery(args, api, extraOptions)
  if (result.error && result.error.status === 401) {
    api.dispatch(authSlice.actions.reset())
  }
  return result
}
